export default class Helpers {
  static redirectTo(url) {
    window.location.href = url;
  }

  static lockScroll() {
    document.body.style.overflow = 'hidden';
  }

  static unlockScroll() {
    document.body.style.overflow = null;
  }

  static isMobile() {
    return /(iPhone|iPod|BlackBerry|Android)/.test(window.navigator.userAgent);
  }

  static blockPointerEvents() {
    document.body.style['pointer-events'] = 'none';
  }

  static unblockPointerEvents() {
    document.body.style['pointer-events'] = null;
  }
}
